<template>
  <v-container fluid>
    <v-row v-if="!loading" justify="center">
      <v-col  cols="12" sm="8" md="4">
        <v-card class="elevation-4">
          <v-toolbar dark flat color="primary">
            <v-toolbar-title>Login form</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon color="white"
                  v-on="on"
                  @click="gotoHome">
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
              </template>
              <span>close</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-form v-model="valid" ref="form" validation>
              <v-text-field
                color="primary"
                label="email"
                name="email"
                prepend-icon="mdi-account"
                type="text"
                v-model="email"
                :rules="emailRules"
              ></v-text-field>
              <v-text-field
                color="primary"
                id="password"
                label="password"
                name="password"
                prepend-icon="mdi-lock"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                v-model="password"
                :rules="passRules"
                hint="min 6 characters"
                @click:append="show = !show"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center" class="mb-4">
              <v-col cols="11">
                <v-btn dark small block
                  class="text-capitalize"
                  color="primary"
                  @click="onSubmit"
                  :loading="loading"
                  :disabled="!valid || loading"
                >sign In
                </v-btn> 
              </v-col>
            </v-row>             
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <div v-else class="text-center">
      <loader></loader>
    </div>
  </v-container>
</template>
<script>
  import Loader from '../layouts/Loader.vue'

  export default {
    data () {
      return {
        email: '',
        password: '',
        valid: false,
        show: false,
        requiredRules: [v => !!v || 'this field is required'], 
        emailRules: [
          v => !!v || 'this field is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid'
        ],
        passRules: [
          v => !!v || 'password is required',
          v => (v && v.length >= 6) || 'password must be more than 6 characters'
        ]
      } 
    },
    computed: {
      loading () {
        return this.$store.getters.loading
      },
      isInstructor () {
        return this.$store.getters.isInstructor
      }
    },
    watch: {
      isInstructor () {
        if (this.$store.getters.isInstructor) {
          this.$router.push('/market/segments')
        }
      }
    },
    methods: {
      async onSubmit (){
        const user = {} 

        if (this.$refs.form.validate()) {
            user.email = this.email
            user.password = this.password
        }
        try {

          await this.$store.dispatch('loginUser', user)

          if (this.isInstructor) {
            this.$router.replace('/admin/market/segments')
          }
          else {
            this.$router.replace('/customer/decisions/pm')
          }
        }
        catch(error) {
          this.$store.dispatch('setError', error.message) 
        }
      },
      gotoHome () {
        this.$router.replace('/')
      },
      registration () {
        this.$router.replace('/registr')
      }
    },
    created () {
      if (this.$route.query['loginError']) {
        this.$store.dispatch('setError', 'Please, signIn to access this page')
      }
    },
    components: {Loader}
  }
</script>

    
